import React, { useEffect, useState } from "react";
import { FileVideo, Loader2, Send } from "lucide-react";
import { Button } from "./ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import ProcedureRecordingsList from "./ProcedureRecordingsList";

export default function ProcedureRecordingPickerDialog({ open, onOpenChange, ticket, onSend }) {
  const [selectedIds, setSelectedIds] = useState([]);
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    if (!open) setSelectedIds([]);
  }, [open, ticket?.id]);

  const handleSend = async () => {
    if (!selectedIds.length || isSending) return;
    setIsSending(true);
    try {
      await onSend(selectedIds);
      setSelectedIds([]);
      onOpenChange(false);
    } catch (_) {
      // The parent presents the API error and keeps this modal open for retry.
    } finally {
      setIsSending(false);
    }
  };

  const selectedLabel = selectedIds.length === 1 ? "Enviar 1 vídeo" : `Enviar ${selectedIds.length} vídeos`;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex h-[92dvh] max-h-[calc(100dvh-1rem)] w-[calc(100%-1rem)] max-w-6xl flex-col gap-0 overflow-hidden rounded-2xl p-0 sm:max-h-[calc(100dvh-3rem)] sm:w-[calc(100%-3rem)]">
        <DialogHeader className="min-w-0 shrink-0 border-b p-4 pr-12 text-left sm:p-6 sm:pr-14">
          <DialogTitle className="flex items-start gap-2 leading-snug"><FileVideo className="mt-0.5 h-5 w-5 shrink-0 text-violet-600" /> Enviar procedimentos ao cliente</DialogTitle>
          <DialogDescription className="[overflow-wrap:anywhere]">
            Pesquise na biblioteca, assista se quiser e selecione um ou mais vídeos para enviar a {ticket?.client_name || "este cliente"}.
          </DialogDescription>
        </DialogHeader>

        <div className="min-h-0 min-w-0 flex-1 overflow-y-auto overscroll-contain bg-gray-50 p-4 sm:p-6">
          <ProcedureRecordingsList
            compact
            selectable
            selectedIds={selectedIds}
            onSelectionChange={setSelectedIds}
          />
        </div>

        <div className="flex shrink-0 flex-col gap-3 border-t bg-white p-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
          <span role="status" className="text-sm text-gray-500">{selectedIds.length ? `${selectedIds.length} selecionado(s)` : "Nenhum vídeo selecionado"}</span>
          <div className="flex flex-col-reverse gap-2 min-[400px]:flex-row">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={isSending}>Cancelar</Button>
            <Button type="button" onClick={handleSend} disabled={!selectedIds.length || isSending} className="bg-violet-600 hover:bg-violet-700">
              {isSending ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Send className="mr-2 h-4 w-4" />}
              {isSending ? "Enviando..." : selectedLabel}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
